"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ThreeDSecureWebviewLoadedAnalyticsEvent = exports.ThreeDSecureWebviewChlngedFailedAnalyticsEvent = exports.ThreeDSecureWebviewChlngedCompletedAnalyticsEvent = exports.ThreeDSecureCompleteAuthSuccessAnalyticsEvent = exports.ThreeDSecureCompleteAuthFailureAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when the 3DS webview loads
 */
var ThreeDSecureWebviewLoadedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('three_d_secure_webview_loaded');
exports.ThreeDSecureWebviewLoadedAnalyticsEvent = ThreeDSecureWebviewLoadedAnalyticsEvent;
/**
 * Triggers when the challenge completes successfully
 */
var ThreeDSecureWebviewChlngedCompletedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('three_d_secure_webview_chlnged_completed');
exports.ThreeDSecureWebviewChlngedCompletedAnalyticsEvent = ThreeDSecureWebviewChlngedCompletedAnalyticsEvent;
/**
 * Triggers if the challenge fails
 */
var ThreeDSecureWebviewChlngedFailedAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('three_d_secure_webview_chlnged_failed');
exports.ThreeDSecureWebviewChlngedFailedAnalyticsEvent = ThreeDSecureWebviewChlngedFailedAnalyticsEvent;
/**
 * Triggers if the completeAuth api call succeeds
 */
var ThreeDSecureCompleteAuthSuccessAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('three_d_secure_complete_auth_success');
exports.ThreeDSecureCompleteAuthSuccessAnalyticsEvent = ThreeDSecureCompleteAuthSuccessAnalyticsEvent;
/**
 * Triggers if the completeAuth api call fails
 */
var ThreeDSecureCompleteAuthFailureAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('three_d_secure_complete_auth_failure');
exports.ThreeDSecureCompleteAuthFailureAnalyticsEvent = ThreeDSecureCompleteAuthFailureAnalyticsEvent;
